import * as Yup from 'yup';
import { DictSubjectIndex } from '@models';

export function useValidationSchema() {
  return Yup.object<DictSubjectIndex>().shape({
    name: Yup.string().nullable().required(),
  });
}
